import CommonContainer from '../../../common/Container/CommonContainer';
import Pagination from '../../../design_system/components/admin_table/pagination/Pagination';
import {MANAGEMENT_DETAIL_TABLE_CONFIG} from '../ManagementDashboard.attribute';
import {useManagementsDetail} from '../model/query/ManagementDetail.query';
import ManagementTable from './ManagementTable/ManagementTable';
import * as S from './ManagementDetail.style';
import {useState} from 'react';

export default function ManagementDetail({ id, variant = 'photoAuth' }) {
    const [page, setPage] = useState(1);
    const { data, isLoading } = useManagementsDetail(variant, page);
    const { icon, title, columns, unit, report_description } = MANAGEMENT_DETAIL_TABLE_CONFIG[variant];
    if (isLoading) return <div>Loading...</div>;
    if (!data) return <div>error..., 다시 시도해 주세요</div>;
    const totalPages = data.total > 0 ? Math.ceil(data.total / 4) : 1;

    return (
        <div id={id}>
            <CommonContainer>
                <S.Container>
                    <S.TableTitleWrapper>
                        {icon}
                        <S.TableTitle>
                            {title} (총 <S.HighlightCount>{data?.total}</S.HighlightCount>
                            {unit})
                        </S.TableTitle>
                    </S.TableTitleWrapper>
                    {report_description && <S.TableDescription>{report_description}</S.TableDescription>}

                    <ManagementTable columns={columns} data={data.data} page={page} />
                    <Pagination
                        wrapperStyle={{ margin: '10px 0' }}
                        totalPages={totalPages}
                        limit={3}
                        page={page}
                        setPage={(page) => {
                            setPage(page);
                        }}
                    />
                </S.Container>
            </CommonContainer>
        </div>
    );
}
